import { BaseEvent } from "@/api/ws/events/BaseEvent";

export type CheckoutProgressUpdatedEvent = {
  id: number;
  checkout_snapshot_id: number;
  status: "incomplete" | "complete";
  step_statuses: {
    id: string;
    is_complete: boolean;
  }[];
};

export default class CheckoutProgressWasUpdatedEvent extends BaseEvent<CheckoutProgressUpdatedEvent> {
  name = ".checkout_progress_updated";
}
